var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(Object.keys(_vm.articlesData).length > 0) ? _c('div', {
    key: _vm.dataReady,
    staticClass: "page-content__container"
  }, [_c('article-view', {
    attrs: {
      "content-data": _vm.articlesData
    }
  }), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95355828","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/content-type/Page.vue
// module id = GtF7
// module chunks = 1